import GlobalStyles from "./GlobalStyles";
import Grid from "@material-ui/core/Grid";
import React from "react";
import DefaultTheme from "../Themes/DefaultTheme";

const SellerDetailForCustomerPageStyles = (Theme) => ({
  ...GlobalStyles(Theme),
  container: {
    paddingRight: "15px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto",
    width: "100%",
    [Theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
    [Theme.breakpoints.up("md")]: {
      maxWidth: "1140px",
    },
  },
  chipStyle: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: Theme.spacing(0.5),
    },
  },
  description: {
    margin: "1.071rem auto 0",
    maxWidth: "600px",
    color: DefaultTheme.palette.default.contrastLight,
    textAlign: "center !important",
  },
  name: {
    marginTop: "-80px",
  },
  imgFluid: {
    maxWidth: "100%",
    height: "auto",
  },
  imgRounded: {
    borderRadius: "6px !important",
  },
  imgRoundedCircle: {
    borderRadius: "50% !important",
  },
  imgRaised: {
    boxShadow:
      "0 5px 15px -8px rgba(0, 0, 0, 0.24), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
  },
  imgGallery: {
    width: "100%",
    marginBottom: "2.142rem",
  },
  imgCardTop: {
    width: "100%",
    borderTopLeftRadius: "calc(.25rem - 1px)",
    borderTopRightRadius: "calc(.25rem - 1px)",
  },
  imgCardBottom: {
    width: "100%",
    borderBottomLeftRadius: "calc(.25rem - 1px)",
    borderBottomRightRadius: "calc(.25rem - 1px)",
  },
  imgCard: {
    width: "100%",
    borderRadius: "calc(.25rem - 1px)",
  },
  imgCardOverlay: {
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    padding: "1.25rem",
  },
  main: {
    position: "relative",
    zIndex: "3",
  },
  mainRaised: {
    borderRadius: "6px",
  },
  title: {
    color: DefaultTheme.palette.dark.lightAlternative,
    margin: "1.75rem 0 0.875rem",
    fontWeight: "700",
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    [Theme.breakpoints.only("xs")]: {
      fontSize: 20,
    },
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: DefaultTheme.palette.default.contrastLight,
  },
  navWrapper: {
    margin: "20px auto 50px auto",
    textAlign: "center",
    boxShadow:
      " 0 2.8px 2.2px rgba(0, 0, 0, 0),0 6.7px 5.3px rgba(0, 0, 0, 0),0 12.5px 10px rgba(0, 0, 0, 0.06),0 22.3px 17.9px rgba(0, 0, 0, 0),0 41.8px 33.4px rgba(0, 0, 0, 0),0 100px 80px rgba(0, 0, 0, 0)",
  },
  profile: {
    textAlign: "center",
    "& img": {
      maxWidth: "160px",
      width: "100%",
      margin: "0 auto",
      transform: "translate3d(0, -50%, 0)",
    },
  },
  settingButtonDiv: {
    marginTop: "-115px",
    height: "120px",
  },
  backButtonDiv: {
    textAlign: "left",
    marginTop: "-120px",
    height: "120px",
    paddingLeft: "150px",
  },
  certificateContainer: {
    height: "300px",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50% 50%",
  },
  text: {
    color: DefaultTheme.palette.dark.contrastText,
    textAlign: "right",
    fontSize: 12,
  },
  lessonText: {
    color: DefaultTheme.palette.dark.contrastText,
    textAlign: "right",
    fontSize: 12,
    [Theme.breakpoints.only("xs")]: {
      fontSize: 10,
    },
  },
  professionText: {
    color: DefaultTheme.palette.dark.contrastText,
    textAlign: "left",
    fontSize: 13,
  },
  titleText: {
    color: DefaultTheme.palette.dark.contrastText,
    textAlign: "left",
    fontSize: 15,
    "@media screen and (max-width: 600px) and (min-width: 400px)": {
      fontSize: 13,
    },
    "@media screen and (max-width: 400px)": {
      fontSize: 11,
    },
  },
  avatar: {
    width: Theme.spacing(12),
    height: Theme.spacing(12),
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
    [Theme.breakpoints.only("xs")]: {
      width: Theme.spacing(10),
      height: Theme.spacing(10),
    },
  },
  avatarGlobal: {
    margin: "auto",
    display: "block",
  },
  sellerNameText: {
    color: DefaultTheme.palette.dark.contrastText,
    textAlign: "left",
    fontSize: 25,
    fontWeight: "bold",
  },
  sellerCreateDate: {
    color: DefaultTheme.palette.dark.contrastText,
    fontSize: 13,
  },
  lessonName: {
    color: DefaultTheme.palette.dark.contrastText,
    textAlign: "left",
    fontSize: 13,
  },
  lessonNameSubCategory: {
    color: DefaultTheme.palette.dark.contrastText,
    textAlign: "left",
    fontSize: 11,
    width: "100%",
  },
  lessonButton: {
    textTransform: "none",
    fontSize: 15,
    backgroundColor: "transparent",
    float: "right",
  },
  titleTextRight: {
    color: DefaultTheme.palette.dark.contrastText,
    textAlign: "right",
    fontSize: 15,
  },
  gridBorder: {
    border: "0.1em solid #e6e6e6",
    borderRadius: "5px",
  },
  lessonPrice: {
    color: Theme.palette.primary.main,
    textAlign: "left",
    fontSize: 16,
    textDecoration: "none",
    textTransform: "none",
    backgroundColor: "transparent",
    float: "right",
    [Theme.breakpoints.only("xs")]: {
      fontSize: "14px",
    },
  },
  lessonPrice2: {
    color: DefaultTheme.palette.primary.main,
    textAlign: "left",
    fontSize: 16,
    textDecoration: "none",
    textTransform: "none",
    backgroundColor: "transparent",
    float: "right",
  },
  bookingLessonPrice: {
    //color: "#348dec",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: 18,
    textDecoration: "none",
    textTransform: "none",
    backgroundColor: "transparent",
    float: "right",
  },
  certificateTitle: {
    color: DefaultTheme.palette.dark.contrastText,
    textAlign: "left",
    fontSize: 18,
    fontWeight: "bold",
  },
  secondaryHeading: {
    fontSize: Theme.typography.pxToRem(15),
    color: Theme.palette.text.secondary,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: Theme.spacing(2),
    textAlign: "center",
    color: Theme.palette.text.secondary,
    boxShadow: "none",
    "@media screen and (max-width: 400px)": {
      padding: "9px",
    },
  },
  paperWithoutPadding: {
    textAlign: "center",
    color: Theme.palette.text.secondary,
    boxShadow: "none",
  },
  commentText: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textDecoration: "none",
    fontStyle: "italic",
    fontSize: 12,
  },
  commentText2: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textDecoration: "none",
    fontStyle: "italic",
    fontSize: 16,
  },
  commentUserName: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textDecoration: "none",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: 12,
  },
  commentUserName2: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textDecoration: "none",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: 18,
  },
  commentAvatar: {
    width: Theme.spacing(7),
    height: Theme.spacing(7),
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  commentDate: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textDecoration: "none",
    textAlign: "center",
    fontSize: 10,
  },
  commentDate2: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textDecoration: "none",
    textAlign: "center",
    fontSize: 12,
  },
  lessonType: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textDecoration: "none",
    textAlign: "center",
    fontSize: 14,
    fontWeight: "bold",
  },
  commentAvatarDetail: {
    width: Theme.spacing(9),
    height: Theme.spacing(9),
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  commentUserNameDetail: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textDecoration: "none",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: 15,
  },
  userButton: {
    textAlign: "left",
    paddingLeft: "0px",
    textTransform: "none",
    fontSize: 20,
    backgroundColor: "transparent",
  },
  alignLeft: {
    textAlign: "left",
  },
  alignRight: {
    textAlign: "right",
  },
  paperStyle: {
    width: "100%",
    boxShadow: "none",
  },
  lessonPriceText: {
    color: DefaultTheme.palette.info.secondAlternative,
    textDecoration: "none",
    fontStyle: "bold",
    fontSize: 20,
    textAlign: "center",
  },
  bookingLessonPriceText: {
    //color: "#348dec",
    textDecoration: "none",
    fontSize: 18,
    textAlign: "left",
    float: "right",
  },
  buttonColor: {
    color: DefaultTheme.palette.dark.alternative,
    textDecoration: "none",
  },
  gridShadow: {
    position: "relative",
    WebkitBoxShadow:
      "0 1px 1px rgba(0, 0, 0, 0.3), 0 0 5px rgba(0, 0, 0, 0.1) inset",
    MozBoxShadow:
      "0 1px 1px rgba(0, 0, 0, 0.3), 0 0 5px rgba(0, 0, 0, 0.1) inset",
    boxShadow: "0 1px 1px rgba(0, 0, 0, 0.3), 0 0 5px rgba(0, 0, 0, 0.1) inset",
  },
  curriculumVitaeText: {
    width: "100%",
    textAlign: "left",
  },
  sellerIntroductoryText: {
    textDecoration: "none",
    fontSize: 12,
    textAlign: "left",
    wordBreak: "break-word",
  },
  fromPriceText: {
    textDecoration: "none",
    fontSize: 8,
    textAlign: "center",
  },
  hideScrollBar: {
    overflow: "hidden",
  },
  priceNote: {
    color: DefaultTheme.palette.dark.lightAlternative,
    textAlign: "center",
    fontSize: 10,
    textDecoration: "none",
    fontWeight: "bold",
  },
  creditNote: {
    color: DefaultTheme.palette.info.secondAlternative,
    textAlign: "left",
    fontSize: 10,
    textDecoration: "none",
    textTransform: "none",
    backgroundColor: "transparent",
    float: "right",
  },
  lessonDetailButton: {
    textTransform: "none",
    textAlign: "left",
    paddingLeft: "0px",
  },
  mainText: {
    color: DefaultTheme.palette.dark.contrastText,
    textAlign: "left",
    fontSize: 20,
    "@media screen and (max-width: 600px) and (min-width: 400px)": {
      fontSize: 18,
    },
    "@media screen and (max-width: 400px)": {
      fontSize: 13,
    },
  },
  dateText: {
    color: DefaultTheme.palette.default.thirdAlternative,
    textAlign: "right",
    fontSize: 12,
  },
  padding5: {
    padding: "5px",
  },
  lessonGrid: {
    border: "1px solid",
    borderRadius: "5px",
    borderColor: DefaultTheme.palette.default.fourthAlternative,
  },
  professionText2: {
    paddingTop: "3px",
    fontWeight: "bold",
  },
  lessonPoint: {
    fontSize: "9px",
    fontWeight: "bold",
  },
  mainDiv: {
    "@media screen and (max-width: 960px) and (min-width: 600px)": {
      width: "80%",
      margin: "auto",
    },
  },
  ratingSize: {
    [Theme.breakpoints.only("xs")]: {
      fontSize: "14px",
    },
  },
  onlineState1: {
    fontSize: 13,
    marginTop: "5px",
    [Theme.breakpoints.only("xs")]: {
      fontSize: "11px",
    },
  },
  onlineState2: {
    fontSize: 11,
    [Theme.breakpoints.only("xs")]: {
      fontSize: "9px",
    },
  },
  aboutMeSentences: {
    textAlign: "left",
    [Theme.breakpoints.only("xs")]: {
      fontSize: "13px",
    },
    wordBreak: "break-word",
  },
  lessonXsGrid: {
    padding: "10px",
    "@media screen and (max-width: 400px)": {
      padding: "unset",
      paddingBlockStart: "10px",
      paddingBlockEnd: "10px",
    },
  },
  shareMediaStyle: {
    fontFamily: "Montserrat",
    textTransform: "none",
    fontSize: "12px",
    textAlign: "center",
  },
  shareModalTitle: {
    fontFamily: "Montserrat",
    textTransform: "none",
    fontWeight: "bold",
    fontSize: "20px",
  },
  shareIconGrid: {
    textAlign: "center",
  },
  userNickText: {
    textAlign: "left",
    fontSize: "12px",
    color: DefaultTheme.palette.dark.alternative,
    fontWeight: "bold",
  },
  breadcrumbStyle: {
    textAlign: "center",
    color: Theme.palette.text.secondary,
  },
  customLessonText: {
    fontFamily: "Montserrat",
    fontSize: "12px",
  },
  priceTextFree: {
    color: DefaultTheme.palette.dark.contrastText,
    textAlign: "center",
    [Theme.breakpoints.down("xs")]: {
      fontSize: 15,
    },
    [Theme.breakpoints.up("sm")]: {
      fontSize: 19,
    },
    display: "flex",
    justifyContent: "center",
  },
});

export default SellerDetailForCustomerPageStyles;
